/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                from 'react';
import { StyledIconInline } from '../StyledIconInline';


/*********************************************************************************
 2. Component
 *********************************************************************************/

const StyledIconIconMailSent = StyledIconInline.extend`
  height: ${props => props.height || '21px'};
  width: ${props => props.width || '25px'};
  transform: translateY(1px);
`;

export const IconMailSent = (props) => (
    <StyledIconIconMailSent {...props}>
        <svg viewBox="0 0 25 21" version="1.1" xmlns="http://www.w3.org/2000/svg"
             xmlnsXlink="http://www.w3.org/1999/xlink">
            <g strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20.894,2.8604 L12.967,9.9884 C12.367,10.5274 11.417,10.5274 10.817,9.9884 L2.89,2.8604"/>
                <path d="M8.2007,10.7256 L2.8907,15.1426"/>
                <path d="M21.0718,17.5 C22.3888,17.5 23.5028,16.477 23.5028,15.212 L23.5028,2.791 C23.5028,1.526 22.4708,
            0.5 21.1538,0.5 L2.8448,0.5 C1.5278,0.5 0.5028,1.526 0.5028,2.791 L0.5028,15.212 C0.5028,16.477 1.5278,
            17.5 2.8448,17.5 L12.3158,17.5"/>
                <path d="M20.0889,12.1318 C18.2139,10.2568 15.1739,10.2568 13.2989,12.1318 C11.4229,14.0078 11.4229,
            17.0468 13.2979,18.9228 C15.1729,20.7978 18.2139,20.7978 20.0889,18.9228 C21.9639,17.0478 21.9639,
            14.0068 20.0889,12.1318 Z"/>
                <polyline points="14.7637 16.3467 15.9097 17.3867 19.0507 14.6707"/>
            </g>
        </svg>
    </StyledIconIconMailSent>
);



// WEBPACK FOOTER //
// ./src/components/atoms/IconMailSent/index.js